<template>
    <div class="inner-wrap">
        <div class="left" :style="{'max-height': height}">
            <h1>Upload Your Trademark Images and Files</h1>
            <div class="list">
                <div v-for="(v, k) in form_data.trademark" :key="`tra` + k" class="item">
                    <Upload
                            :action="upload_url" :data="{ dir: 'template' }"
                            :before-upload="(file)=>onBeforeUpload(file, 'trademark', k, 'file')"
                            :show-upload-list="false"
                    >
                        <template v-if="!!!v.raw">
                            <div class="upload-wrap cursor">
                                <img class="icon-upload" src="@/assets/images/design/icon-upload-pink.png"/>
                                <p>Click to Upload Trademark Image/File</p>
                            </div>
                        </template>
                        <template v-else-if="util.test_image(v.raw)">
                            <div class="image-box">
                            <img @click.stop :src="v.raw" class="" style="width:100%;height: 100%;object-fit:contain;" v-viewer />
                            <div class="replace-btn">
                                <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                <div class="text">Re-upload</div>
                            </div>
                        </div>
                        </template>
                        <template v-else>
                            <div class="doc-file">
                        <a class="doc-wrap" target="_blank" :href="v.raw" @click.stop>
                            <img :src="util.get_image_icon(v.raw_name)" class="icon-doc" />
                            <span>{{v.raw_name}}</span>
                        </a>
                        <div class="replace-file">
                                <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                <div class="text">Re-upload</div>
                            </div>
                        </div>
                        </template>
                    </Upload>
                    <div class="bz">
                        <label >Remarks:</label>
                        <input :value="form_data.trademark[k].content" @input="input($event, 'trademark', k)"  placeholder="Please enter remarks" />
                    </div>
                    <img src="@/assets/images/design/icon-del2.png" alt="" class="icon-del cursor" @click.stop="del_trademark(k)">
                </div>
                <div class="btn btn-other cursor" @click="add_trademark">
                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                    Upload File
                </div>
            </div>

            <h1>Upload Your Label Images and Files</h1>
            <div class="list">
                <div v-for="(v, k) in form_data.label" :key="`lab` + k" class="item">
                    <Upload
                            :action="upload_url" :data="{ dir: 'template' }"
                            :before-upload="(file)=>onBeforeUpload(file, 'label', k, 'file')"
                            :show-upload-list="false"
                    >
                        <template v-if="!!!v.raw">
                            <div class="upload-wrap cursor">
                                <img class="icon-upload" src="@/assets/images/design/icon-upload-pink.png"/>
                                <p>Click to Upload Label Image/File</p>
                            </div>
                        </template>
                        <template v-else-if="util.test_image(v.raw)">
                            <div class="image-box">
                            <img @click.stop :src="v.raw" class="" style="width:100%;height: 100%;object-fit:contain;" v-viewer />
                            <div class="replace-btn">
                                <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                <div class="text">Re-upload</div>
                            </div>
                        </div>
                        </template>
                        <template v-else>
                            <div class="doc-file">
                        <a class="doc-wrap" target="_blank" :href="v.raw" @click.stop>
                            <img :src="util.get_image_icon(v.raw_name)" class="icon-doc" />
                            <span>{{v.raw_name}}</span>
                        </a>
                        <div class="replace-file">
                                <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                <div class="text">Re-upload</div>
                            </div>
                        </div>
                        </template>
                    </Upload>
                    <div class="bz">
                        <label >Remarks:</label>
                        <input :value="form_data.label[k].content" @input="input($event, 'label', k)"  placeholder="请输入说明" />
                    </div>
                    <img src="@/assets/images/design/icon-del2.png" alt="" class="icon-del cursor" @click.stop="del_label(k)">
                </div>
                <div class="btn btn-other cursor" @click="add_label">
                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                    Upload File
                </div>
            </div>

            <h1>Other Requirements and Remarks</h1>
            <textarea :value="form_data.other_remark" @input="input_other" cols="30" placeholder="If you have other requirements or remarks, please fill them in here, within 200 characters..." rows="5"></textarea>
            <h1 >Upload Other Attachments</h1>
            <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    :before-upload="(file)=>onBeforeUpload2(file)"
                    :show-upload-list="false"
            >
                <div class="btn btn-other cursor">
                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                    Upload File
                </div>
            </Upload>
            <div class="other-file-list">
                <div class="file-box" v-for="(v, k) in form_data.other_file" :key="`of` + k" >
                <a :href="v.path" class="file-item" target="_blank">
                    <img :src="util.get_image_icon(v.name)" class="icon-doc" />
                    {{ v.name }}
                </a>
                <div class="replace-file">
                                <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                <div class="text">Re-upload</div>
                            </div>
                            <img class="icon-del cursor" src="@/assets/images/design/icon-del.png" @click.prevent="del_other_file(k)" alt="">
            </div>
            </div>
        </div>
        <div class="right">
            <Lesson v-if="is_lesson_show"></Lesson>
        </div>
    </div>
</template>

<script>
    import util from '@/utils/util'
    import {mapState} from 'vuex'
    import Lesson from "./Lesson.vue";
    import { uploadFileToOSS } from "@/utils/oss";
    export default {
        name: "Other",
        data() {
            return {
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                util: util
            }
        },
        components: {
            Lesson
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
            }),
        },
        mounted() {
            //防止在点开弹窗以后直接刷新页面导致再次进入弹窗不关闭的问题
            this.$store.commit('design/hide_lesson_popup');
        },
        methods: {
            input($event, field, k) {
                let object = this.form_data[field][k]
                object.content = $event.target.value
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
            onBeforeUpload(file, field, k, child_field) {
                uploadFileToOSS(file, 'template').then(url => {
                    let object = this.form_data[field][k]
                    if (child_field === "file") {
                        object.raw = url;
                        object.raw_name = file.name;
                    } else if (child_field === "image") {
                        object.image = url;
                    }
                    this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
                })
                return false;
            },
            add_trademark() {
                let object = {image: "", content: "", raw: "", raw_name: "",}
                this.$store.commit("design/arr_push_one", {key: 'trademark', value: object})
            },
            del_trademark(k) {
                this.$store.commit('design/arr_remove_one', {key: 'trademark', index: k})
            },
            add_label() {
                let object = {image: "", content: "", raw: "", raw_name: "",}
                this.$store.commit("design/arr_push_one", {key: 'label', value: object})
            },
            del_label(k) {
                this.$store.commit('design/arr_remove_one', {key: 'label', index: k})
            },
            input_other(e) {
                this.$store.commit('design/update_common', {key: 'other_remark', value: e.target.value})
            },
            del_other_file(k) {
                this.$store.commit('design/arr_remove_one', {key: 'other_file', index: k})
            },
            onBeforeUpload2(file) {
                if(this.form_data.other_file.length >= 10) {
                    this.$layer.msg(`Up to 10 files can be added`)
                    return
                }
                uploadFileToOSS(file, 'template').then(url => {
                    let object = { name: file.name, path: url }
                    this.$store.commit('design/arr_push_one', {key: 'other_file', value: object})
                })
                return false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;
        .left {
            padding: 0 30px 100px 30px;
            width: 490px;
            background: white;
            overflow: auto;
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 18px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 15px 0;
            }

            .list {
                display: flex;
                flex-wrap: wrap;
                margin: 10px 0;
                .item {
                    position: relative;
                    width: 420px;
                    padding: 10px;
                    margin-bottom: 25px;
                    background: #FAFAFA;
                    .upload-wrap {
                        width: 418px;
                        height: 140px;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: center;
                        justify-content: center;
                        .icon-upload {
                            width: 24px;
                            height: 24px;
                        }
                        p {
                            width: 100%;
                            margin-top: 5px;
                            color: #FA3D5A;
                            text-align: center;
                        }
                    }
                    .doc-file{
                    display:flex;
                    align-items:center;
                    .doc-wrap {
                        display: flex;
                        flex-wrap: nowrap;
                        align-items: center;
                        .icon-doc {
                            width: 24px;
                            height: 24px;
                            margin:0 10px;
                        }
                    }
                    .replace-file{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        width:100px;
                        background:rgba(0,0,0,0.4);
                        color:#ffffff;
                        font-size:13px;
                        cursor:pointer;
                        .ico{
                            width:18px;
                            height:18px;
                        }
                    }
                }
                    .bz {
                        background: white;
                        display: flex;
                        flex-wrap: nowrap;
                        align-items: center;
                        height: 50px;
                        margin-top: 16px;
                        label {
                            font-size: 13px;
                            margin-left: 10px;
                        }
                        input {
                            height: 50px;
                            line-height: 50px;
                            background: white;
                            border: none;
                            outline: none;
                        }
                    }

                    .icon-del {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 25px;
                        height: 25px;
                        z-index: 1000;
                    }

                    .image-box{
                    width:400px;
                    height:100px;
                    position:relative;
                    .replace-btn{
                        width:100px;
                        position:absolute;
                        bottom:11px;
                        left:50%;
                        transform:translateX(-50%);
                        background:rgba(0,0,0,0.4);
                        color:#ffffff;
                        font-size:13px;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        cursor:pointer;
                        .ico{
                            width:18px;
                            height:18px;
                            // color:#ffffff;
                        }
                        .text{}
                    }
                }
                }

                .btn-continue {
                    width: 420px;
                    height: 55px;
                    line-height: 55px;
                    color: #666666;
                    font-size: 14px;
                    text-align: center;
                    margin: 10px 0;
                    border-radius: 10px;
                    border: 1px solid #ccc;
                }
            }

            textarea {
                width: 420px;
                height: 180px;
                padding: 15px;
                background: #F8F9FC;
                border-radius: 5px ;
                border: 1px solid #D1D1D1;
            }

            .other-file-list {
                display: flex;
                flex-wrap: wrap;
                .file-box{
                    display:flex;
                    align-items:center;
                    width: 485px;
                    height: 42px;
                    background: #f3f3f3;
                    position:relative;
                    margin: 10px 5px;
                    .file-item {
                        position: relative;
                        line-height: 42px;
                        color: #1a1a1a;
                        font-size: 12px;
                        padding-left: 55px;
                        .icon-doc  {
                            position: absolute;
                            top: 5px;
                            left: 15px;
                            width: 32px;
                            height: 32px;
                        }
                    }
                    .icon-del {
                        position: absolute;
                        top: 12px;
                        right: 15px;
                        width: 20px;
                        height: 20px;
                        z-index: 10;
                    }
                    .replace-file{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        width:100px;
                        background:rgba(0,0,0,0.4);
                        color:#ffffff;
                        font-size:13px;
                        cursor:pointer;
                        .ico{
                            width:18px;
                            height:18px;
                        }
                    }
                }
            }

            .btn-other {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 426px;
                height: 56px;
                background: #FFFFFF;
                border: 1px solid #B3B3B3;
                border-radius: 5px;
                color: #1D1D1D;
                font-size: 14px;
                text-align: center;
                margin: 10px 0;
                .icon {
                    width: 24px;
                    height: 24px;
                }
            }

        }
        .right {
            // margin: 0 auto;
            display:flex;
            align-items:center;
            justify-content:center;
            // width:100%;
            flex:1;
        }
    }

</style>
